import { connectToChild } from '../../../../shared/app/vendor/penpal';
import frameTemplate from './ui-modern-frame.tpl.html';
import './ui-modern-frame.less';
import { appConfig } from '../../../../shared/app/constants/app-config';
import { windowEventHelperModule } from '../../../../shared/app/helpers/window-event-helper/window-event-helper';

export const uiModernFrameComponentModule = angular
  .module('Q.components.ui-modern-frame', [windowEventHelperModule])
  .component('uiModernFrame', {
    template: frameTemplate,
    bindings: {
      route: '<',
      api: '<',
      scrolling: '<',
      onFocus: '&',
    },
    controller: function UiModernFrameCtrl(
      $element,
      $scope,
      $location,
      $timeout,
      $log,
    ) {
      function iframeUrlBase() {
        if ($location.host().indexOf('localhost') >= 0) {
          return 'http://localhost:8082/ui-modern/'; // Port base for development
        }
        return '/ui-modern/'; // Path base for production
      }

      const ctrl = this;

      $scope.$on(
        'document:focusoutActiveElement',
        ($e, event, activeElement) => {
          if (activeElement === $element.find('iframe')[0]) {
            ctrl.onFocus();
          }
        },
      );

      ctrl.$onInit = () => {
        ctrl.loading = true;
        const iframe = $element.find('iframe')[0];
        iframe.src = iframeUrlBase() + ctrl.route;

        if (ctrl.api) {
          ctrl.connection = connectToChild({
            iframe: $element.find('iframe')[0],
            methods: ctrl.api,
            timeout: 300000,
          });
          ctrl.connection.promise
            .then(() => {
              ctrl.loading = false;
            })
            .catch((err) => {
              if (!ctrl.$destroyed && !appConfig.devMode) {
                $log.error(err);
              }
            });
        } else {
          $timeout(() => (ctrl.loading = false), 0);
        }
        $timeout(() => (ctrl.loading = false), 5000);
      };

      ctrl.$onChanges = (changes) => {
        if (changes.route) {
          // reload the iframe if the URL changes
          ctrl.$onInit();
        }
      };

      ctrl.$onDestroy = () => {
        ctrl.$destroyed = true;

        if (ctrl.connection) {
          try {
            ctrl.connection.destroy();
          } catch (err) {
            /* ignore errors */
          }
          ctrl.connection = null;
        }
      };
    },
  });
